import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { Box } from "@mui/material";
function DetailsCard(_a) {
    var title = _a.title, description = _a.description;
    return (_jsxs(WrapperContainer, { "$flexDirection": "column", "$padding": "1rem 0", "$gap": "1rem", children: [_jsxs(CustomText, { "$color": "#8c8181", "$fontWeight": "bold", "$display": "block", children: [title, _jsx(Box, { sx: { borderBottom: "1px solid #eee", width: "100%", mt: "4px" } })] }), _jsx(CustomText, { as: "div", children: description })] }));
}
export default DetailsCard;
